import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CoreService } from '../../helper/core/core.service';
import { BuNameService } from '../../helper/core/bu-name.service';
import { Store, select } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { setTimezoneFilter, toggleFilterOnline, toggleFilterPhysical, toggleModalFilterMobile } from '../../store/filter/filter.action';
import { AppState } from '../../store';
import { map, take } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TealiumUtagService } from '../../tealium/utag.service';
import { FragmentCheckerService } from '../../helper/utils/fragment-checker.service'; // Mettez à jour le chemin selon votre structure de fichiers

@Component({
  selector: 'app-prestation',
  templateUrl: './prestation.component.html',
  styleUrls: ['./prestation.component.scss']
})
export class PrestationComponent implements OnInit {

  public errorMsg: string = "";
  public buSlug: string;
  public bu: any = false;
  public errorApi: boolean = false;
  public spotlight: any = null
  public onlineWorkshop: any = []
  public physicalWorkshop: any = []
  public activeOnlineWorkshopSwitch: boolean = true
  public activePhysicalWorkshopSwitch: boolean = true
  public numberItemsOnlineWorkshop: number = 3
  public numberItemsPhysicalWorkshop: number = 3
  private filtersSubject = new BehaviorSubject<{ physical: boolean, online: boolean }>({ physical: false, online: false });
  public filters$: Observable<any> = this.filtersSubject.asObservable();
  public hasCommercialEvents: boolean = true;
  public dataTimezone: any = [
    {
      id: 0,
      name: '',
      label: 'Tous les fuseaux'
    }
  ];
  public filterTimezone: any = '';
  public formTimezone: FormGroup;
  public trackingId: string;
  public fragmentActive: boolean;
  public config: any;
  timezone = new FormControl();
  
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private coreService: CoreService,
    private buNameService: BuNameService,
    private tealium: TealiumUtagService,
    private fragmentCheckerService: FragmentCheckerService,
    private store: Store<AppState>,
  ) {
  }

  ngOnInit() {
    $(document).ready(function () {
      $(document).foundation();
    });
    this.fragmentActive = this.fragmentCheckerService.hasFragment();

    const storedFilters = JSON.parse(localStorage.getItem('orange_rse_filter')) || {};
    const physicalFilter = storedFilters.physical || false;
    const onlineFilter = storedFilters.online || false;
    this.route.fragment.subscribe(fragment => {
      if (fragment) {
        this.filtersSubject.next({ physical: true, online: true });
        this.updateLocalStorage({ physical: true, online: true });
      } else {
        this.filtersSubject.next({ physical: physicalFilter, online: onlineFilter });
      }
    });

    // Récupère le Slug de la BU
    this.buSlug = this.route.snapshot.paramMap.get('bu');
    // Attribution de l'url de la BU dans le header
    this.buNameService.url = this.buSlug; 
    
    /**
     *  Récupère les évènements
     *  de la BU
    */
   
   this.getEvents(this.buSlug);
   
   this.filters$ = this.store.pipe(select('filter'))    

    this.filters$.pipe(take(1)).subscribe(el => {
      this.filterTimezone = el.timezone
      if(el.timezone === '')
        this.timezone.setValue('Tous les fuseaux')
      else this.timezone.setValue(el.timezone)
    })

    this.formTimezone = this.fb.group({
      timezone: this.timezone 
    });

    
  }

  updateFilter(filter: string, value: boolean) {
    const currentFilters = this.filtersSubject.getValue();
    const updatedFilters = { ...currentFilters, [filter]: value };
    this.filtersSubject.next(updatedFilters);
    this.updateLocalStorage(updatedFilters);
  }

  private updateLocalStorage(filters: { physical: boolean, online: boolean }) {
    const storedFilters = JSON.parse(localStorage.getItem('orange_rse_filter')) || {};
    const updatedFilters = { ...storedFilters, ...filters };
    localStorage.setItem('orange_rse_filter', JSON.stringify(updatedFilters));
  }
  
  private scrollToAnchor(anchor: string) {
    setTimeout(() => {
      const element = document.getElementById(anchor);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); 
  }

  ngAfterViewInit() {
    window.addEventListener('load', () => {
      setTimeout(() => {
        this.route.fragment.subscribe(fragment => {
          if (fragment) {
            this.scrollToAnchor(fragment);
          }
        });
      }, 1000);
    })
  }
  /**
   * Récupère les évènements de la BU
   *
   * @param buSlug | string : Slug de la BU
   */
  private getEvents(buSlug) {
    this.coreService.getEvents(buSlug).subscribe(
      (data) => {
        // Attribution des éléments de la BU
        this.onlineWorkshop = data.onlineWorkshop;
        this.physicalWorkshop = data.physicalWorkshop;
        this.hasCommercialEvents = data.hasCommercialEvents;
        this.trackingId = data.trackingId;
        if(data.filters.timezone){
          data.filters.timezone.forEach((el, index) => {
            this.dataTimezone = [...this.dataTimezone, {
              id: 'timezone-'+index,
              name: el,
              label: el
            }]
          })
        }

        this.spotlight = data.spotlight;

        this.buNameService.name = data.name;
        this.buNameService.title = data.name;
        this.buNameService.img = "default";
        this.tealium.view("homepage", document.title, this.buSlug, "global", this.trackingId);
        
      }, (dataError) => {
        this.errorApi = true;
      }, () => {
        $(document).ready(() => {
          this.initSlider();
          // this.equalizeShortDesc();
        })
      });
  }

  public equalizeShortDesc(): void {
    $('.ateliers_item').each(function () {
      // Cache the highest
      var highestBox = 0;
      // Select and loop the elements you want to equalise
      $('.ateliers_description', this).each(function () {
        // If this box is higher than the cached highest then store it
        if ($(this).height() > highestBox) {
          highestBox = $(this).height();
        }
      });

      // Set the height of all those children to whichever was highest
      $('.ateliers_description').height(highestBox);
    });
  }

  changeTimezone(value){
    this.store.dispatch(setTimezoneFilter(value))
    this.filterTimezone = value;
  }

  setOnlineWorkshop(){
    return this.filters$.pipe(take(1),map(
      filter => {
        return this.onlineWorkshop.slice(0,this.numberItemsOnlineWorkshop)
        // if(filter.timezone !== ''){
        //   return this.onlineWorkshop.filter(workshop => workshop.timezone === filter.timezone).slice(0,this.numberItemsOnlineWorkshop);
        // }else{
        //   return this.onlineWorkshop.slice(0,this.numberItemsOnlineWorkshop)
        // }
      } 
    ))
  }

  setPhysicalWorkshop(){
    return this.filters$.pipe(take(1),map(
      filter => {
        if(filter.timezone !== ''){
          return this.physicalWorkshop.filter(workshop => workshop.timezone === filter.timezone).slice(0,this.numberItemsPhysicalWorkshop);
        }else{
          return this.physicalWorkshop.slice(0,this.numberItemsPhysicalWorkshop)
        }
      } 
    ))
  }

  filteredTimezoneWorkshopOnline(){
    if(this.filterTimezone !== '')
      return this.onlineWorkshop.some(el => el.timezone === this.filterTimezone);
    else return true;
  }

  filteredTimezoneWorkshopPhysical(){
    if(this.filterTimezone !== '')
      return this.physicalWorkshop.some(el => el.timezone === this.filterTimezone);
    else return true;
  }

  


  goToAteliers() {
    $('html, body').animate({
      scrollTop: $(".ateliers_titles").offset().top - $('.header__container').innerHeight() - 20
    }, 1000);
  }

  toggleSwitchOnlineWorkshop() {
    this.store.dispatch(toggleFilterOnline())
  }

  toggleSwitchPhysicalWorkshop() {
    this.store.dispatch(toggleFilterPhysical())
  }

  toggleModalFilterMobile() {
    this.store.dispatch(toggleModalFilterMobile())
  }

  addItemsOnlineWorkshop() {
    this.numberItemsOnlineWorkshop += 3;
  }

  addItemsPhysicalWorkshop() {
    this.numberItemsPhysicalWorkshop += 3;
  }

  /**
   * Envoie les infos utag
   * @param track_zone | string : Nom du tracking
   * @param track_nom | string : Nom du tracking
   * @param track_cible | string : Slug du tracking
   */
  public sendLink(track_zone, track_nom, track_cible = "") {
    console.log("🚀 ~ file: prestation.component.ts ~ line 227 ~ PrestationComponent ~ sendLink ~ this.route.snapshot.paramMap.get('bu') + '_' + track_zone", this.route.snapshot.paramMap.get('bu') + '_' + track_zone)
    console.log("🚀 ~ file: prestation.component.ts ~ line 229 ~ PrestationComponent ~ sendLink ~ track_nom", track_nom)
    console.log("🚀 ~ file: prestation.component.ts ~ line 231 ~ PrestationComponent ~ sendLink ~ window.location.href + '/' + track_cible", window.location.href + '/' + track_cible)
    this.tealium.link({
      'track_zone': this.route.snapshot.paramMap.get('bu') + '_' + track_zone,
      'track_nom': track_nom,
      'track_cible': window.location.href + '/' + track_cible
    });
  }

  private initSlider(): void {
    var mySwiper = new Swiper('#event__slider', {
      loop: false,
      slidesPerView: 3,
      spaceBetween: 15,
      slideClass: 'swiper-slide',

      // Pagination
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },

      breakpoints: {
        1280: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 1
        },
      },
      on: {
        paginationRender: function () {
          if (this.pagination.bullets.length > 1)
            $(this.pagination.el).show();
          else
            $(this.pagination.el).hide();
        },
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/prestation/prestation.component.ts